import AuthenticationType from '@alltrails/analytics/enums/AuthenticationType';
import User from '@alltrails/shared/types/User';
import { authSuccessCallback } from './AuthHandlers';

const appleRedirectHandler = (user: User) => {
  const params = new URLSearchParams(window.location.search);
  const appleOAuth = params.get('apple_oauth');
  const isCollabListInvite = params.has('is_collab_list_invite');
  if (appleOAuth) {
    const is_sign_up = appleOAuth === 'signup';
    authSuccessCallback({ is_sign_up, user }, AuthenticationType.Apple, isCollabListInvite);
    const search = params.toString();
    window.history.replaceState(null, null, window.location.pathname + (search !== '' ? `?${search}` : ''));
  }
};

// eslint-disable-next-line import/prefer-default-export
export { appleRedirectHandler };
